<div class="bs-callout bs-callout-{{type}}">
  <h4 class="{{type}}" (click)="toggle()" [ngStyle]="{'cursor':canExpand ? 'pointer' : 'default' }">
    @if (canExpand) {
      <button class="btn btn-link">
        <i class="{{type}} fa"
        [ngClass]="{'fa-chevron-circle-down': isExpanded, 'fa-chevron-circle-right' : !isExpanded}"></i>
      </button>
    }
    <ng-content select="[title]"></ng-content>
  </h4>
  @if (isExpanded) {
    <div>
      <ng-content select="[body]"></ng-content>
    </div>
  }
</div>
